import Vue from 'vue'
import Router from 'vue-router'
import User from '@/views/User'
// import BigscreenSales from '@/views/Bigscreen_sales'
import NewBigscreenSales from '@/views/bigscreenSales/index'
import Logindp from '@/views/Logindp'
import ProPOSHIP from '@/views/bigscreenSales/propoship'
import Shipparts from '@/views/bigscreenSales/shipparts'
import Companychart from '@/views/bigscreenSales/companychart'
import Workroomdp from '@/views/workroomdp/index'

// import Workhours from '@/views/Workhours'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'logindp',
      component: Logindp
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/new',
      name: 'new',
      component: NewBigscreenSales
    },
    {
      path: '/propo',
      name: 'propo',
      component: ProPOSHIP
    },
    {
      path: '/shipparts',
      name: 'shipparts',
      component: Shipparts
    },
    {
      path: '/companychart',
      name: 'companychart',
      component: Companychart
    },
    {
      path: '/workroomdp',
      name: 'workroomdp',
      component: Workroomdp
    },

    
    // {
    //   path: '/Workhours',
    //   name: 'workhours',
    //   component: workhours
    // }

  ]
})
router.beforeEach((to, from, next) => {
  // 首先，我们先看一看to和from参数，next就是执行的意思，不写页面是不会跳转的
  // console.log(to, from);
  if (to.meta.isAuth) { // 判断是否需要鉴权
    if (localStorage.getItem('name') === '张三') {
      next()
    } else {
      alert('不好意思，姓名不对，没有权限')
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js